/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminWorkerKindStats
 */
export interface AdminWorkerKindStats {
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerKindStats
     */
    completed24h: number;
    /**
     * Failed24h are jobs discarded (out of attempts) or cancelled in the last 24 hours.
     * @type {number}
     * @memberof AdminWorkerKindStats
     */
    failed24h: number;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerKindStats
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerKindStats
     */
    lastCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerKindStats
     */
    lastFailedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminWorkerKindStats
     */
    nextScheduledAt?: string;
    /**
     * Queued jobs: available, scheduled, pending or waiting for a retry.
     * @type {number}
     * @memberof AdminWorkerKindStats
     */
    queued: number;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkerKindStats
     */
    running: number;
}

export function AdminWorkerKindStatsFromJSON(json: any): AdminWorkerKindStats {
    return AdminWorkerKindStatsFromJSONTyped(json, false);
}

export function AdminWorkerKindStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerKindStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'completed24h': json['completed24h'],
        'failed24h': json['failed24h'],
        'kind': json['kind'],
        'lastCompletedAt': !exists(json, 'lastCompletedAt') ? undefined : json['lastCompletedAt'],
        'lastFailedAt': !exists(json, 'lastFailedAt') ? undefined : json['lastFailedAt'],
        'nextScheduledAt': !exists(json, 'nextScheduledAt') ? undefined : json['nextScheduledAt'],
        'queued': json['queued'],
        'running': json['running'],
    };
}

export function AdminWorkerKindStatsToJSON(value?: AdminWorkerKindStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'completed24h': value.completed24h,
        'failed24h': value.failed24h,
        'kind': value.kind,
        'lastCompletedAt': value.lastCompletedAt,
        'lastFailedAt': value.lastFailedAt,
        'nextScheduledAt': value.nextScheduledAt,
        'queued': value.queued,
        'running': value.running,
    };
}

